/**
 * LangServer API 설정
 * nginx 프록시를 통해 환경별로 라우팅됨
 */

export const LANGSERVER_CONFIG = {
  BASE_URL: '/langserver',
  TIMEOUT: 10000,
  DEBOUNCE_DELAY: 500,
} as const;

export const ALLOWED_PACKAGES = [
  'numpy',
  'pandas',
  'scikit-learn',
  'scipy',
  'matplotlib',
  'seaborn',
  'plotly',
  'torch',
  'tensorflow',
  'keras',
  'xgboost',
  'lightgbm',
  'catboost',
  'requests',
  'httpx',
] as const;

export type AllowedPackage = (typeof ALLOWED_PACKAGES)[number];
